<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option></lcs-option>
      } @for (user of users | async; track trackBy(user)) {
      <lcs-option [value]="user" id="lcs-option-id-{{ user.userId }}">
         {{ user.name }}
      </lcs-option>
      }
   </div>
</ng-template>
